import PropTypes from "prop-types";
import {
  SafetyOutlined,
  SolutionOutlined,
  TeamOutlined,
  BankOutlined,
  FileSearchOutlined,
  RetweetOutlined,
} from "@ant-design/icons";

import { BiFingerprint, BiCreditCard } from "react-icons/bi";
import { GoChecklist } from "react-icons/go";
import { IoTicketOutline } from "react-icons/io5";

const icons = {
  security: (props) => <SafetyOutlined {...props} />,
  users: (props) => <TeamOutlined {...props} />,
  roles: (props) => <SolutionOutlined {...props} />,
  companies: (props) => <BankOutlined {...props} />,
  devices: (props) => <BiFingerprint {...props} />,
  licenses: (props) => <BiCreditCard {...props} />,
  activations: (props) => <GoChecklist {...props} />,
  reports: (props) => <FileSearchOutlined {...props} />,
  transfers: (props) => <RetweetOutlined {...props} />,
  coupons: (props) => <IoTicketOutline {...props} />,
};

const CIcon = (props) => {
  const { type, onClick, ...rest } = props;

  const Icon = icons[type];
  if (!Icon) return <></>;

  const handleClick = (e) => {
    if (onClick && typeof onClick === "function") onClick(e);
  };
  return <Icon {...rest} onClick={handleClick} />;
};
CIcon.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
};
export default CIcon;
